import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { IAddressRegionDto, IBuildTypeDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { LotMigratorAddressSectionComponent } from '../shared-sections/lot-migrator-address-section.component';
import { LotMigratorLotBuildSectionComponent } from '../shared-sections/lot-migrator-lot-build-section.component';
import { LotMigratorPricingCostsSectionComponent } from '../shared-sections/lot-migrator-pricing-costs-section.component';
import { LotMigratorRoomsParkingSectionComponent } from '../shared-sections/lot-migrator-rooms-parking-section.component';

@Component({
    selector: 'cb-lot-migrator-standalone-form',
    standalone: true,
    imports: [
        MatDividerModule,
        LotMigratorAddressSectionComponent,
        LotMigratorLotBuildSectionComponent,
        LotMigratorRoomsParkingSectionComponent,
        LotMigratorPricingCostsSectionComponent
    ],
    templateUrl: './lot-migrator-standalone-form.component.html',
    styleUrls: ['./lot-migrator-standalone-form.component.scss']
})
export class LotMigratorStandaloneFormComponent {
    @Input({ required: true }) public lotForm!: FormGroup;
    @Input() public addressRegions: IAddressRegionDto[] = [];
    @Input() public buildTypeOptions: IBuildTypeDto[] = [];
    @Input() public contractTypes: { id: number; label: string }[] = [];
    @Input() public lotTypes: { id: number; label: string }[] = [];
}
